import React, { useEffect, useMemo, useState } from "react";
import { Loader } from "../../loader";
import { useForm } from "react-hook-form";
import { fetchAPI } from "../../service/Encrtyption";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Gift from "../../../assets/images/gift.png";
import CashReward from "../../../assets/images/cashReward.png";
import GiftReward from "../../../assets/images/giftReward.png";
import SuccessIcon from "../../../assets/images/successIcon.png";
import Bottle from "../../../assets/images/Bottle.png";
import CustomModal from "../../modal";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useParamarshDetails } from "../../../utils";
import { formControlClasses } from "@mui/material";
import Accordion from "react-bootstrap/Accordion";
import { amountTransferData, rewardMoney } from "../../auth/redux/store";
import ReactGA from 'react-ga4';
import {
  INDIAN_MOBILE_PATTERN,
  numericInputProps,
  sanitizeIndianMobile,
} from "../../../utils/inputConstraints";
import {
  getTransferErrorMessage,
  isTransferSuccess,
  parsePaymentApiResponse,
} from "../../../utils/paymentResponse";
import Header from "../../layout/Header";

const styles = `
 .loader-overlay {
  position: fixed;
  top: 56px;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999999999999;
}

.loader-spinner {
  border: 10px solid #5F6368;
  border-top: 10px solid var(--secondary-color);
  border-radius: 50%;
  width: 140px;
  height: 140px;
  animation: spin 1s linear infinite;
}

.loader-img {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 99999
}
`;

export const UpiDetails = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const { lang } = useParams();
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    clearErrors,
  } = useForm();
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const genunityData = useSelector((state) => state.genunityData);
  const myRewardsData = useSelector((state) => state.myRewardsData);
  const user = useSelector((state) => state.user);
  const claimValue = useSelector((state) => state.claimValue);
  const [rewardUpdateModal, setRewardUpdateModal] = useState(false);
  const [succeMessage, setsucceMessage] = useState("");
  const [errroMsg, setErrorMsg] = useState("");
  const [searchParams] = useSearchParams();
  const isreclaim = searchParams.get("isreclaim");


  const loginMobile = user?.mobileNumber || sessionStorage.getItem("mbn") || "";
  const dispatch = useDispatch();
  const browserType = sessionStorage.getItem("browserName") || "web";


  // const beneficiaryName = useMemo(() => {
  //   const fromProfile = 
  //   [user?.firstName, user?.middleName, user?.lastName]
  //     .filter(Boolean)
  //     .join(" ")
  //     .trim();
  //   return fromProfile || "";
  // }, [user?.firstName, user?.lastName, user?.middleName]);

  const beneficiaryName = sessionStorage.getItem("name") || "";

  const reclaimDataObj = useSelector((state) => state.reclaimDataObj);
  const amount = useSelector((state) => state.amount);
  console.log("amount" + amount);
  console.log("claimValue" + claimValue);

  // const [fetchData, rewardsData, reclaimRewards, reclaimData, cashRewardsData] = useParamarshDetails();
  // console.log("rewardsData--------" + JSON.stringify(rewardsData));
  // console.log("cashRewardsData--------" + JSON.stringify(cashRewardsData));
  // console.log("claimValue in upidetails" + JSON.stringify(claimValue));

  // const [formData, setFormData] = useState({
  //   cashFreeTransactionId: 0,
  //   cashRewards: "",
  //   claimIDs: [],
  //   dsrProgramId: 0,
  //   ecouponFarmerMapId: 0,
  //   paymentMode: "upi",
  //   phoneNumber: mobileNumber,
  //   seadProgramId: 0,
  //   upiVpa:
  //     clickedType?.toLowerCase() === "upilinkedmobno"
  //       ? mobileNumber
  //       : "",
  //   destinationURL: "/cashFreeReward/cashFreePaymentModeRequest_V2",
  // }); 

  // const [upiValue, setUpiValue] = useState(
  //   clickedType?.toLowerCase() === "upilinkedmobno"
  //     ? mobileNumber
  //     : ""
  // );

  //   const handleChange = (fieldName, value) => {
  //   setFormData((prevData) => ({
  //     ...prevData,
  //     [fieldName]: value,
  //     cashRewards: claimValue ? cashRewardsData : amount,
  //     claimIDs: claimValue ? rewardsData : [],
  //   }));
  // };

  // useEffect(() => {
  //   if (clickedType?.toLowerCase() === "upilinkedmobno") {
  //     handleChange("upiVpa", mobileNumber);
  //   }
  // }, [clickedType, mobileNumber]);


  // useEffect(() => {
  //   if (clickedType?.toLowerCase() === "upilinkedmobno") {
  //     const rewardsValue =
  //       claimValue
  //         ? (cashRewardsData ?? amount ?? "0")
  //         : (amount ?? "0");

  //     setFormData((prevData) => ({
  //       ...prevData,
  //       upiVpa: mobileNumber,
  //       cashRewards: rewardsValue,
  //       claimIDs: claimValue ? rewardsData || [] : [],
  //     })); 
  //     console.log("cashRewardsData =", cashRewardsData);
  //     console.log("amount =", amount);
  //     console.log("final rewardsValue =", rewardsValue);
  //   }
  // }, [
  //   clickedType,
  //   mobileNumber,
  //   cashRewardsData,
  //   claimValue,
  //   amount,
  //   rewardsData,
  // ]); 

  // useEffect(() => {
  //   //  debugger;
  //   if (!claimValue) {
  //     // If claimValue is falsy (null, undefined, false, etc.), update formData
  //     setFormData((prevData) => ({
  //       ...prevData,
  //       cashFreeTransactionId: reclaimDataObj.cashFreeTransactionId,
  //       cashRewards: reclaimDataObj.amount,
  //       claimIDs: [],
  //     }));
  //   } else {
  //     // If claimValue is truthy, fetch data (assuming fetchData is defined)
  //     fetchData();
  //   }
  // }, [claimValue, reclaimDataObj]);


  // // const handleChange = (fieldName, value) => { 
  // //   setFormData((prevData) => ({
  // //     ...prevData,
  // //     [fieldName]: value,
  // //     cashRewards: claimValue ? cashRewardsData : amount,
  // //     claimIDs: claimValue ? rewardsData : []
  // //   }));
  // //   console.log("setdata"+JSON.stringify(formData));
  // // };

  // // console.log("formData+--------------"+JSON.stringify(formData));

  // const onSubmit = async () => {
  //   debugger;
  //   setLoading(true);

  //   alert("formData on submit" + JSON.stringify(formData.cashRewards));

  //   ReactGA.event({
  //     category: 'User UPI Details',
  //     action: 'CLAIM_UPI_BTN'
  //   });

  //   console.log("formData on submit" + JSON.stringify(formData));

  //   if (!formData.cashRewards || !formData.upiVpa || (formData.claimIDs && formData.claimIDs.length == 0)) {
  //     setErrorMsg(t("sessionExpired"));
  //     setTimeout(() => {
  //       navigate(`/${lang}/home`);
  //     }, 2000);
  //     return;
  //   }

  //   try {
  //     // debugger;
  //     const responseData = await fetchAPI(process.env.REACT_APP_API_URL, formData, { mobileNumber: mobileNumber });
  //     //  debugger; 
  //     console.log("upiformdatasubmit" + JSON.stringify(formData));
  //     const jsonReposneData = JSON.parse(responseData);

  //     if (jsonReposneData?.statusCode === "200" && jsonReposneData.subCode == "200") {
  //       navigate(`/${lang}/transferSucces`)

  //     } else if (jsonReposneData.statusCode == "500") {

  //       setErrorMessage(jsonReposneData.secondaryMsg);
  //       setErrorMessage(jsonReposneData.message);

  //     } else if (jsonReposneData.subCode == "201") {

  //       //statusCode  // message
  //       setErrorMessage(jsonReposneData.secondaryMsg);
  //       setTimeout(() => {
  //         // Navigate to '/home' after 1 second
  //         navigate(`/${lang}/home`)
  //       }, 2000);
  //     } else {

  //       //statusCode  // message
  //       setErrorMessage(jsonReposneData.secondaryMsg);
  //       setTimeout(() => {
  //         // Navigate to '/home' after 1 second
  //         navigate(`/${lang}/home`)
  //       }, 2000);

  //     }

  //   } catch (error) {
  //     console.error("Error fetching API:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const hide = () => {
    setErrorMessage(""); // Assuming you have a state to manage the error message
  };

  const [fetchData, rewardsData, reclaimRewards, reclaimData, cashRewardsData] =
    useParamarshDetails();

  const location = useLocation();
  const clickedType = location.state?.type;
  const isUpiLinkedMobile = clickedType?.toLowerCase() === "upilinkedmobno";
  const isUpi = clickedType?.toLowerCase() === "upi";

  const [upiValue, setUpiValue] = useState(() => {
    if (!isUpiLinkedMobile) return "";
    return sanitizeIndianMobile(loginMobile);
  });

  const [formData, setFormData] = useState({
    cashFreeTransactionId: 0,
    cashRewards: "0",
    claimIDs: [],
    dsrProgramId: 0,
    ecouponFarmerMapId: 0,
    paymentMode: clickedType,
    phoneNumber: "",
    seadProgramId: 0,
    upiVpa: "",
    accountName: beneficiaryName,
    destinationURL: "/cashFreeReward/cashFreePaymentModeRequest_V2",
  });

  const syncUpiFields = (rawValue) => {
    const sanitized = sanitizeIndianMobile(rawValue);
    setUpiValue(sanitized);
    setValue("upiVpa", sanitized, { shouldValidate: !!sanitized });
    setFormData((prevData) => ({
      ...prevData,
      upiVpa: sanitized,
      phoneNumber: sanitized || loginMobile,
    }));
    clearErrors("upiVpa");
  };


  // ---------------- HANDLE CHANGE ----------------

  const handleChange = (fieldName, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [fieldName]: value,
    }));
    clearErrors(fieldName);
  };

  const handleUpiInputChange = (rawValue) => {
    syncUpiFields(rawValue);
  };


  // ---------------- DEFAULT UPI VALUE ----------------

  // useEffect(() => {
  //   if (isUpiLinkedMobile && loginMobile) {
  //     syncUpiFields(loginMobile);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps -- prefill once login mobile is available
  // }, [isUpiLinkedMobile, loginMobile]);


  // ---------------- SET CASH REWARDS ----------------

  useEffect(() => {
    const rewardsValue = claimValue
      ? (cashRewardsData ?? amount ?? "0")
      : (amount ?? reclaimDataObj?.amount ?? "0");

    setFormData((prevData) => ({
      ...prevData,
      cashRewards: rewardsValue,
      claimIDs: claimValue ? (rewardsData || []) : [],
    }));

    console.log("cashRewardsData =", cashRewardsData);
    console.log("Claim IDs =", rewardsData);
    console.log("amount =", amount);
    console.log("rewardsValue =", rewardsValue);

  }, [
    cashRewardsData,
    amount,
    claimValue,
    rewardsData,
    reclaimDataObj,
  ]);
  // ---------------- RECLAIM DATA ----------------

  useEffect(() => {
    if (beneficiaryName) {
      setFormData((prevData) => ({
        ...prevData,
        accountName: beneficiaryName,
      }));
    }
  }, [beneficiaryName]);

  useEffect(() => {
    if (!claimValue && reclaimDataObj) {
      debugger;
      setFormData((prevData) => ({
        ...prevData,
        cashFreeTransactionId:
          reclaimDataObj?.cashFreeTransactionId || 0,
        cashRewards:
          reclaimDataObj?.amount || amount || "0",
        claimIDs: [],
      }));
    } else {
      // alert("fetching data from useParamarshDetails");
      fetchData();
    }
  }, [claimValue, reclaimDataObj]);

  // ---------------- DEBUG ----------------

  useEffect(() => {
    console.log("UPDATED FORMDATA => ", formData);
  }, [formData]);


  // ---------------- SUBMIT ----------------

  const onSubmit = async () => {
    try {
      setLoading(true);

      const upiPhone =
        sanitizeIndianMobile(upiValue) ||
        sanitizeIndianMobile(formData?.upiVpa) ||
        loginMobile;

      // FINAL SAFE PAYLOAD
      const payload = {
        ...formData,

        cashRewards:
          formData?.cashRewards ??
          cashRewardsData ??
          amount ??
          reclaimDataObj?.amount ??
          "0",

        claimIDs:
          formData?.claimIDs?.length > 0
            ? formData.claimIDs
            : (rewardsData || []),

        upiVpa: upiPhone,
        phoneNumber: upiPhone, // upi value 
        mobileNumber: loginMobile, // login mobile as fallback 
        accountName:
          formData?.accountName || beneficiaryName,
      };

      // alert(
      //   "payload on submit => " +
      //   JSON.stringify(payload)
      // );

      console.log("FINAL PAYLOAD => ", payload);

      ReactGA.event({
        category: "User UPI Details",
        action: "CLAIM_UPI_BTN",
      });

      // VALIDATION
      if (!payload.cashRewards || !payload.upiVpa || !payload.claimIDs) {
        setErrorMsg(t("sessionExpired"));

        setTimeout(() => {
          navigate(`/${lang}/giftHistory`);
        }, 2000);

        return;
      }

      const responseData = await fetchAPI(
        process.env.REACT_APP_API_URL,
        payload,
        {
          mobileNumber: loginMobile,
          appLangCode: lang || i18n.language,
          customerId:
            user?.customerId || sessionStorage.getItem("cid") || "",
          deviceType: "web",
          browserType: browserType,
        }
      );

      const jsonReposneData = parsePaymentApiResponse(responseData);

      console.log("API RESPONSE => ", jsonReposneData);

      if (isTransferSuccess(jsonReposneData)) {
        dispatch(amountTransferData(jsonReposneData));
        navigate(`/${lang}/transferSucces`);
        return;
      }

      dispatch(amountTransferData(jsonReposneData));
      setErrorMessage(getTransferErrorMessage(jsonReposneData));
      navigate(`/${lang}/transferFailed`);

    } catch (error) {
      navigate(`/${lang}/transferFailed`);
      console.error("Error fetching API:", error);
    } finally {
      setLoading(false);
    }
  };


  return (
    <>
      <style>{styles}</style>
      <Header />
      <div className="main">
        <div className="container p-0">
          {loading && <Loader />}
          {/* <Loader /> */}
          <div className="card border-0">
            <Accordion.Header id="transfer">
              <div>
                <i className="fa fa-chevron-left text-white mr-2"
                  onClick={() => navigate(`/${lang}/giftHistory`)}
                ></i>
                {t("transfer")}
              </div>
              <span className="float-end">
                <span>₹{amount ? amount : cashRewardsData}</span>
              </span>
            </Accordion.Header>
            <div className="card-body px-2 pt-0 pb-2">
              <div className="px-4 py-2 mt-3">
                <i className="fa fa-arrow-left mr-2" onClick={() => navigate(`/${lang}/paymentmode?isreclaim=${isreclaim}`)}></i>
                {/* <span className="infoText mb-0">{t("UPI")}</span> */}
                <span className="infoText mb-0">
                  {isUpiLinkedMobile ? t("upiLinkedMobileNumber") : t("upiLinkedMobileNumber")}
                </span>

                <hr className="mt-2" />

                <div className="mt-5">
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div>
                      {/* <input
                        type="text"
                        autoComplete="off"
                        className={`form-control bankInput mb-2 ${errors.upiVpa ? "is-invalid" : ""
                          }`}
                        placeholder="UPI VPA"
                        name="upiVpa"
                        id="upiVpa"
                        {...register("upiVpa", {
                          required: t("UPIErrorMsg"),
                        })}
                        //onChange={(e) => handleChange("upiVpa", e.target.value)}
                        onKeyUp={(e) => handleChange("upiVpa", e.target.value)}
                      /> */}

                      <input
                        {...numericInputProps}
                        autoComplete="off"
                        className={`form-control bankInput mb-2 ${errors.upiVpa ? "is-invalid" : ""
                          }`}
                        placeholder={
                          isUpiLinkedMobile
                            ? t("UPILinkedMobileNumber")
                            : t("UPI")
                        }
                        name="upiVpa"
                        // value={upiValue}
                        id="upiVpa"
                        maxLength={10}
                        {...register("upiVpa", {
                          required: t("UPIErrorMsg"),
                          validate: (value) =>
                            INDIAN_MOBILE_PATTERN.test(value || "") ||
                            t("mobileErrorMsg"),
                        })}
                        onChange={(e) => handleUpiInputChange(e.target.value)}
                      />

                      {errorMessage && (
                        <div
                          className="alert alert-warning alert-dismissible fade show mt-2"
                          role="alert"
                        >
                          {errorMessage}
                          <button
                            type="button"
                            className="close"
                            onClick={hide}
                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                      )}

                      {errroMsg && (
                        <>
                          <div
                            className="alert alert-warning alert-dismissible fade show mt-2"
                            role="alert"
                          >
                            {errroMsg}
                            <button
                              type="button"
                              className="close"
                              onClick={hide}
                            >
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                        </>
                      )}
                    </div>
                    {/* <button
                      type="submit"
                      className="btn btn-secondary w-100 py-3
                      center-textbtn mt-3 text-white text-uppercase
                      registerSubmitBtn"
                      id="submitBtn"
                    >
                      {t("confirm")}
                    </button> */}

                    <div class="selectPaymentFooter">
                      <button type="submit" className="btn btn-secondary w-100 py-2 btnshadow center-textbtn mt-3 text-white text-uppercase" id="submitBtn">{t("confirm")}</button>
                    </div>

                  </form>
                </div>
                <CustomModal
                  id={"rewardUpdateModal"}
                  title={""}
                  content={
                    <>
                      <img
                        src={SuccessIcon}
                        alt="SuccessIcon"
                        className="succesIcon"
                      />
                      <img src={Bottle} alt="Bottle" />
                      <p className="congratulationsText">{succeMessage}</p>
                      <p className="rewardText">{t("updatesOnReward")}</p>
                    </>
                  }
                  show={rewardUpdateModal}
                  onHide={() => setRewardUpdateModal(false)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
